import styled from 'styled-components';
import { theme } from '../../../styles/constants';

export const StyledBasicButton = styled.button`
  position: relative;
  width: 100%;
  height: 4.6rem;
  padding: ${props => (props.$isLoading ? '0' : '1.2rem')};
  border-radius: 8px;
  color: ${theme.colors.white};
  font-size: 1.6rem;
  font-weight: 500;
  line-height: normal;
  border: 1px solid transparent;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    background: #9da4ae;
    color: ${theme.colors.white};
  }
`;

export const StyledButton = styled(StyledBasicButton)`
  background: #3f88f7;
`;

export const StyledTransparentButton = styled(StyledBasicButton)`
  background-color: transparent;
  color: ${theme.colors.textColor};
`;

export const ButtonIconWrapper = styled.div`
  height: 4.4rem;
  display: flex;
  align-items: center;
`;
